export default function Loading() {
  return <div>Just a moment...</div>;
}
